export enum TransferTypeenum {
      INTERNAL = 'INTERNAL',
      SALE_ORDER = 'SALE ORDER',
      WAREHOUSE = 'WAREHOUSE',
      PLANT = 'PLANT'
}